import SEO from '../../components/base/SEO';
import { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import RankingList from './components/RankingList';
import ComparisonTable from './components/ComparisonTable';
import ApplicationGuide from './components/ApplicationGuide';
import StudentBenefits from './components/StudentBenefits';
import CampaignSection from './components/CampaignSection';
import Footer from './components/Footer';
import Breadcrumb from '../../components/feature/Breadcrumb';

export default function StudentPage() {
  const [showFloatingCTA, setShowFloatingCTA] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowFloatingCTA(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "学生向けクレジットカード特集",
    "description": "学生でも作れるクレジットカードを厳選紹介。年会費無料、学生限定特典、ポイント高還元など、学生生活をお得にするカードが見つかります。"
  };

  const faqData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "学生でもクレジットカードは作れますか？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "はい、18歳以上（高校生を除く）であれば学生でもクレジットカードを作ることができます。多くのカード会社が学生向けの審査基準を設けており、アルバイト収入がなくても申込み可能なカードも多数あります。"
        }
      },
      {
        "@type": "Question",
        "name": "学生向けカードの審査は厳しいですか？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "学生向けカードは一般カードに比べて審査が通りやすい傾向にあります。学生という身分自体が信用となり、親権者の同意があれば収入がなくても発行されるケースが多いです。"
        }
      },
      {
        "@type": "Question",
        "name": "学生カードは卒業後も使えますか？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "はい、多くの学生カードは卒業後も継続して利用できます。卒業後は自動的に一般カードに切り替わるか、そのまま同じカードを使い続けられます。年会費条件が変わる場合があるので、事前に確認しておきましょう。"
        }
      }
    ]
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="学生向けクレジットカードおすすめランキング｜2026年最新版｜クレカ比較ナビ"
        description="学生でも作れるクレジットカードを徹底比較。審査が通りやすく学生限定特典が充実したおすすめカードをランキング形式で紹介。年会費無料・高還元率・申込条件・審査情報も詳しく解説。"
        keywords="クレジットカード,学生,学生向け,審査,大学生,年会費無料,おすすめ,ランキング"
        canonical="/student"
        structuredData={[structuredData, faqData]}
      />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqData) }} />
      <Header />
      <Breadcrumb items={[
        { label: 'ホーム', path: '/' },
        { label: '学生向け' }
      ]} />
      <Hero />
      <RankingList />
      <ComparisonTable />
      <StudentBenefits />
      <ApplicationGuide />
      
      {/* FAQ Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="text-2xl font-bold text-[#003366] mb-8 text-center">よくある質問</h2>
          <div className="space-y-4">
            {faqData.mainEntity.map((faq, index) => (
              <div key={index} className="bg-white rounded-xl p-6 shadow-sm">
                <h3 className="font-bold text-[#003366] mb-3 flex items-start gap-2">
                  <span className="text-[#14B8A6] font-bold">Q.</span>
                  {faq.name}
                </h3>
                <p className="text-gray-700 text-sm leading-relaxed pl-6">
                  <span className="text-[#DC2626] font-bold">A.</span> {faq.acceptedAnswer.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CampaignSection />
      <Footer />

      {/* スクロール追従CTA */}
      {showFloatingCTA && (
        <div className="fixed bottom-6 right-6 z-50 animate-bounce">
          <a
            href="#ranking"
            className="flex items-center gap-2 bg-[#DC2626] hover:bg-[#B91C1C] text-white font-bold px-6 py-4 rounded-full shadow-2xl transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-up-line"></i>
            おすすめカードを見る
          </a>
        </div>
      )}
    </div>
  );
}
